import type { BookableSessionId } from "@@/shared/acquire/sessions/bookable-session-id";
import {
    nowIsoAndUnix,
    type IsoAndUnixTimestamp,
} from "@@/shared/date-time/iso-and-unix";
import type { Time } from "@@/shared/date-time/time";
import type { OrderId } from "@@/shared/orders/order-id";
import { randomInt } from "@@/utilities/random-int";
import { zeroPad } from "@@/utilities/zero-pad";
import type { Except } from "type-fest";
import { lasseMajaIdFactory, type LasseMajaId } from "./lasse-maja-id";

const men = [1, 3, 5];
const women = [2, 4];

type FactoryParams = Except<
    LasseMajaData,
    "_id" | "_type" | "_createdAt" | "_status"
>;

const lasseMajaFactory = (params: FactoryParams): LasseMajaData => {
    return {
        ...params,
        _id: lasseMajaIdFactory(),
        _type: "LASSE_MAJA_DATA",
        _createdAt: nowIsoAndUnix(),
        _status: "ACTIVE",
    };
};

type LasseMajaData = {
    _id: LasseMajaId;
    _type: "LASSE_MAJA_DATA";
    _createdAt: IsoAndUnixTimestamp;
    _status: "ACTIVE" | "REMOVED";
    bookedTime: Time;
    session: BookableSessionId;
    orderId: OrderId;
    //Random number to avoid collisions per day
    randomSeedId: string;
    // [Villian][Suspect] i.e. 0103
    data: string;
    //unique day
    fullDate: string;
};

const generateLMData = () => {
    const villian = randomInt({ min: 1, max: 5 });

    if (men.includes(villian)) {
        const randomSuspectWomen =
            women[Math.floor(Math.random() * women.length)];
        return zeroPad(villian, 2) + zeroPad(randomSuspectWomen, 2);
    }

    const randomSuspectMan = men[Math.floor(Math.random() * men.length)];
    return zeroPad(villian, 2) + zeroPad(randomSuspectMan, 2);
};

export { generateLMData, lasseMajaFactory };
export type { LasseMajaData };
